module.exports = __webpack_public_path__ + "img/tai-chi.3b5b1b79.jpg";